import React from 'react';
import LanguageIcon from 'assets/language_grey.svg';
import DeleteIcon from 'assets/delete.svg';

const SeedDetailsCard = (props) => {
  console.log('props from table', props);
  return (
    <div className="flex flex-wrap w-full items-center text-md text-md lg:text-lg rounded-md border border-gray-300 px-4 py-4">
      <div className="w-1/12">
        <img src={LanguageIcon} width="30" height="30" />
      </div>
      <div className="w-4/12 xl:w-6/12 text-left">{`${props.name}`}</div>
      <div className="w-3/12">Added : {`${props.createdAt}`}</div>
      <div className="w-2/12 xl:w-1/12 flex items-center justify-center">
        <div class="relative inline-block w-10 ml-4 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="toggle"
            id="toggle"
            checked={props.isActive}
            class="focus:outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label
            for="toggle"
            class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
          ></label>
        </div>
      </div>
      <div className="w-2/12 xl:w-1/12">
        <div
          title="Delete"
          className="bg-red-500 px-2 py-2 w-10 h-10 rounded-md cursor-pointer mx-auto"
        >
          <img className="w-full h-full" src={DeleteIcon} />
        </div>
      </div>
    </div>
  );
};

export default SeedDetailsCard;
